import React, { useEffect, useState } from "react";
import { Button, Col, Form, Input, Row, Select, Avatar, Checkbox } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { LeftOutlined, UserOutlined } from "@ant-design/icons";
import { IShippingInfoProps } from "../../models/interface/IShippingInfoProps";
import { ROUTER_PATH } from "../../common/constant";
import { common } from "../../services";
import IProvince from "../../models/provinceModel";
import { localizeRouteKey, validatePhoneNumber } from "../../shared/helpers";
import IDistrict from "../../models/districtModel";
import IShippingInfo from "../../models/shippingInfoModel";
import IWard from "../../models/wardModel";
import { selectCart } from "../../redux/reducers/slice/cart";
import { selectShippingInfoList } from "../../redux/reducers/slice/profile";
import { getUserInfoLocal } from "../../services/profile";
import { signOut } from "../../redux/reducers/slice/auth";
import AuthModal from "../../components/wishButton/authModal";
import { Link } from "react-router-dom";

const { getProvinces, getDistricts, getWards } = common;

const ShippingInfo = (props: IShippingInfoProps) => {
  const { history, t, goToPaymentMethod } = props;
  const [isSignInModal, setIsSignInModal] = React.useState(false);
  const [form] = Form.useForm<IShippingInfo>();
  const [provinces, setProvinces] = useState<IProvince[]>([]);
  const [districts, setDistricts] = useState<IDistrict[]>([]);
  const [wards, setWards] = useState<IWard[]>([]);
  const carts = useSelector(selectCart);
  const deliveryInfos = useSelector(selectShippingInfoList);
  const user = getUserInfoLocal();
  const logined = user != undefined && user != null;
  const dispatch = useDispatch();

  const shippingInfoDataSource = deliveryInfos?.map((item, i) => {
    let _item = { ...item };
    _item.display = `${_item.full_name_recevied ?? ""}, ${
      _item.phone_number
    }, ${_item.address?.full_address}`;
    return _item;
  });

  shippingInfoDataSource?.push({
    _id: "",
    address: null,
    email: "",
    first_name: "",
    last_name: "",
    phone_number: "",
    display: t("shipping_add_new_info"),
  });

  const onFinish = (values: IShippingInfo) => {
    delete values.agreement;

    if (values.address) {
      if (values.address.province) {
        const province = provinces.find(
          (x) => x.id == values.address?.province?.id
        );
        if (province) {
          values.address.province.name = province.name;
          values.address.province.label = province.displayName;
        }
      }

      if (values.address.district) {
        const district = districts.find(
          (x) => x.id == values.address?.district?.id
        );
        if (district) {
          values.address.district.name = district.name;
          values.address.district.label = district.displayName;
        }
      }

      if (values.address.ward) {
        const ward = wards.find((x) => x.id == values.address?.ward?.id);
        if (ward) {
          values.address.ward.name = ward.name;
          values.address.ward.label = ward.displayName;
        }
      }
      values.address.country = 1;
      values.address.full_address = `${values.address.street}, ${values.address?.ward?.label}, ${values.address?.district?.label}, ${values.address?.province?.label}`;
    }

    if (!values.note) {
      values.note = "";
    }

    if (goToPaymentMethod) {
      goToPaymentMethod(values);
    }
  };

  useEffect(() => {
    getProvinces((cb) => {
      if (cb) {
        setProvinces(cb);
      }
    });

    const inputs = document.querySelectorAll(".ant-select-selector input");
    if (inputs) {
      inputs.forEach((e) => {
        e.setAttribute("autocomplete", "stopDamnAutocomplete");
      });
    }
  }, []);

  useEffect(() => {
    if (carts?.shipping_info) {
      form.setFieldsValue(carts.shipping_info);
      if (carts.shipping_info?.address) {
        getDistricts(carts.shipping_info.address?.province?.id, (cb) => {
          if (cb) {
            setDistricts(cb);
          }
        });

        getWards(carts.shipping_info.address?.district?.id, (cb) => {
          if (cb) {
            setWards(cb);
          }
        });
      }
    }
  }, [carts?.shipping_info]);

  const handelOnChangeProvince = (provinceId: any) => {
    let address = form.getFieldsValue()?.address;
    if (address) {
      form.setFieldsValue({
        address: {
          ...address,
          district: null,
          ward: null,
        },
      });
    }

    getDistricts(provinceId, (cb) => {
      if (cb) {
        setDistricts(cb);
      }
    });
  };

  const handelOnChangeDistrict = (districtId: any) => {
    let address = form.getFieldsValue()?.address;
    if (address) {
      form.setFieldsValue({
        address: {
          ...address,
          ward: null,
        },
      });
    }

    getWards(districtId, (cb) => {
      if (cb) {
        setWards(cb);
      }
    });
  };

  const handelOnChangeShippingInfo = (value: any) => {
    const shippingInfo = shippingInfoDataSource?.find((x) => x._id == value);

    if (shippingInfo) {
      form.setFieldsValue(shippingInfo);
      if (shippingInfo?.address?.province?.id) {
        getDistricts(shippingInfo?.address?.province?.id, (cb) => {
          if (cb) {
            setDistricts(cb);
          }
        });
      }

      if (shippingInfo?.address?.district?.id) {
        getWards(shippingInfo?.address?.district?.id, (cb) => {
          if (cb) {
            setWards(cb);
          }
        });
      }
    }
  };

  const handleSignOut = async () => {
    await dispatch(await signOut());
  };

  const openAuthModal = () => {
    setIsSignInModal(true);
  };

  const closeAuthModal = () => {
    setIsSignInModal(false);
  };

  return (
    <>
      <div>
        <h2 style={{ fontFamily: "IBM Plex Serif" }}>
          {t("shipping_info_title")}
        </h2>
        {!logined ? (
          <span>
            {t("do_you_already_have_an_account")}{" "}
            <a
              onClick={openAuthModal}
              // to={localizeRouteKey(ROUTER_PATH.SIGN_IN)}
            >
              {t("btn_sign_in")}
            </a>
          </span>
        ) : (
          <div className="checkout-account-section">
            <div>
              <Avatar size={50} icon={<UserOutlined />} />
            </div>
            <div className="checkout-account-info">
              <span>
                {user?.full_name}{" "}
                {user?.phone_number && `(${user?.phone_number})`}
              </span>
              <a onClick={() => handleSignOut()}>{t("btn_sign_out")}</a>
            </div>
          </div>
        )}
      </div>
      <div className="form-shipping-info">
        <Form
          layout={"vertical"}
          form={form}
          autoComplete="off"
          onFinish={onFinish}>
          {logined ? (
            <Form.Item
              className="kd-input-form"
              label={t("shipping_archived_address")}
              name="_id">
              <Row align="middle" justify="space-between">
                <Col span={24}>
                  <Select
                    style={{ width: "100%" }}
                    placeholder={t("shipping_archived_address")}
                    onChange={(value) => handelOnChangeShippingInfo(value)}>
                    {shippingInfoDataSource?.map((item, i) => (
                      <Select.Option
                        key={`${item._id}_${i}`}
                        value={item._id ? item._id : ""}>
                        {item.display}
                      </Select.Option>
                    ))}
                  </Select>
                </Col>
              </Row>
            </Form.Item>
          ) : (
            <Form.Item required name="_id" hidden={true}>
              <Input hidden />
            </Form.Item>
          )}
          <Row align="middle" justify="space-between">
            <Col span={24}>
              <Form.Item
                required
                className="kd-input-form"
                label={t("full_name_recevied")}
                name="full_name_recevied"
                rules={[
                  {
                    required: true,
                    message: t("full_name_recevied_valid"),
                  },
                ]}>
                <Input placeholder={t("full_name_recevied")} />
              </Form.Item>
            </Col>
            {/* <Col span={12}>
              <Form.Item
                required
                className="kd-input-form"
                label={t("customer_last_name")}
                name="last_name"
                rules={[
                  {
                    required: true,
                    message: t("customer_last_name_valid"),
                  },
                ]}>
                <Input placeholder={t("customer_last_name")} />
              </Form.Item>
            </Col> */}
          </Row>
          <Row align="middle" justify="space-between">
            <Col span={11}>
              <Form.Item
                // required
                className="kd-input-form"
                label={t("customer_email")}
                name="email"
                rules={[
                  {
                    // required: true,
                    message: t("customer_email_valid"),
                  },
                  {
                    type: "email",
                    message: "Emall",
                  },
                ]}>
                <Input placeholder={t("customer_email")} type={"email"} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                required
                className="kd-input-form"
                label={t("customer_phone_number")}
                name="phone_number"
                rules={[
                  {
                    required: true,
                    message: t("customer_phone_number_is_empty"),
                  },
                  {
                    validator: (rule, value, callback) =>
                      validatePhoneNumber(value, callback, t),
                  },
                ]}>
                <Input placeholder={t("customer_phone_number")} />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item
            required
            className="kd-input-form"
            label={t("customer_address")}
            name={["address", "street"]}
            rules={[
              {
                required: true,
                message: t("customer_address_valid"),
              },
            ]}>
            <Input placeholder={t("customer_address_placeholder")} />
          </Form.Item>
          <Form.Item
            required
            className="kd-input-form"
            label={t("customer_province_id")}
            name={["address", "province", "id"]}
            rules={[
              {
                required: true,
                message: t("customer_province_id_valid"),
              },
            ]}>
            <Select
              showSearch
              placeholder={t("customer_province_id")}
              optionFilterProp="children"
              onChange={(value) => handelOnChangeProvince(value)}
              filterOption={(input, option) =>
                option?.children?.toLowerCase()?.indexOf(input.toLowerCase()) >=
                0
              }>
              {provinces.map((item, i) => (
                <Select.Option key={item.id} value={item.id}>
                  {item.displayName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            required
            className="kd-input-form"
            label={t("customer_district_id")}
            name={["address", "district", "id"]}
            rules={[
              {
                required: true,
                message: t("customer_district_id_valid"),
              },
            ]}>
            <Select
              showSearch
              placeholder={t("customer_district_id")}
              optionFilterProp="children"
              onChange={(value) => handelOnChangeDistrict(value)}
              filterOption={(input, option) =>
                option?.children?.toLowerCase()?.indexOf(input.toLowerCase()) >=
                0
              }>
              {districts.map((item, i) => (
                <Select.Option key={item.id} value={item.id}>
                  {item.displayName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            required
            className="kd-input-form"
            label={t("customer_ward_id")}
            name={["address", "ward", "id"]}
            rules={[
              {
                required: true,
                message: t("customer_ward_id_valid"),
              },
            ]}>
            <Select
              showSearch
              placeholder={t("customer_ward_id")}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option?.children?.toLowerCase()?.indexOf(input.toLowerCase()) >=
                0
              }>
              {wards.map((item, i) => (
                <Select.Option key={item.id} value={item.id}>
                  {item.displayName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            className="kd-input-form"
            label={t("shipping_info_note")}
            name={"note"}>
            <Input.TextArea placeholder={t("shipping_info_note")} />
          </Form.Item>
          {!logined ? (
            <Form.Item
              name="agreement"
              valuePropName="checked"
              rules={[
                {
                  validator: (_, value) =>
                    value
                      ? Promise.resolve()
                      : Promise.reject(
                          new Error(t("policy_agreement_require"))
                        ),
                },
              ]}>
              <Checkbox>
                <span className="message" style={{ color: "black" }}>
                  {t("policy_agreement_description")}
                  <Link
                    to={localizeRouteKey(ROUTER_PATH.POLICY_AND_GENERAL_TERMS)}>
                    {t("policy_agreement_link")}
                  </Link>
                  {t("policy_agreement_suffix")}
                </span>
              </Checkbox>
            </Form.Item>
          ) : null}

          <Row
            align="middle"
            justify="space-between"
            className="from-shipping-info-footer">
            <Col lg={11} md={24}>
              <Button
                type="link"
                icon={<LeftOutlined />}
                size={"large"}
                className="go-to-cart"
                onClick={() =>
                  history?.replace(localizeRouteKey(ROUTER_PATH.CART))
                }>
                {t("shopping_cart_title")}
              </Button>
            </Col>
            <Col lg={12} md={24}>
              <Button
                htmlType="submit"
                size={"large"}
                className="go-to-payment kd-btn-primary-2">
                {t("shopping_go_to_payment")}
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
      <AuthModal
        isSignInModal={isSignInModal}
        closeAuthModal={closeAuthModal}
        {...props}
      />
    </>
  );
};

export default ShippingInfo;
